import { Box, Card, CardContent, Divider } from '@mui/material';
import Header from '@/component/Header';
import ExcelBetSwapUpload from '@/component/excel/ExcelBetSwapUpload';
export default function ExcelUploadBetSwap() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="사용자 스왑 상태 변경" />
          <Divider />
          <CardContent>
            <ExcelBetSwapUpload />
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
